module.exports = __webpack_public_path__ + "img/property_logo_frey.9f6b626d.png";